import Body from './Body';
import Column from './Column';

export default class Header extends Body {

    constructor(options) { 
        options = options || {};
        if( ! options.hasOwnProperty('columns') ) {
            options = { columns : options };
        }

        if( ! options.hasOwnProperty('rows') ) {
            options.rows = [];
        }

        if( ! options.hasOwnProperty('fixedColumns') ) {
            options.fixedColumns = [];
        }

        super(options);
        this.setColumns(options.columns);
        this.fixedColumns = options.fixedColumns;
    }

    setColumns(columnList)
    {
        this.columns = [];
        for( let key in columnList ) {
            if( ! columnList.hasOwnProperty(key) ) continue;
            let column = columnList[key];
            if( ! ( column instanceof Column ) ) {
                column = new Column(column);
            }
            this.columns.push(column);
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/table_v3/Header.js